<template>
<nav class="nav">
	<teleport v-if="isMob" to="body">
		<transition name="fade">
			<div class="nav__overlay" v-if="open" @click="open = false"></div>
		</transition>
		<transition name="nav">
			<div class="nav__inner" v-if="open" data-scroll-lock-scrollable>
				<router-link class="nav__logo" :to="{name: 'index'}">
					<img src="/images/Logo.svg" alt="" class="nav__logo-img">
				</router-link>
				<ul class="nav__list">
					<li class="nav__li" v-for="item in currentItems" :class="[page === item.link ? 'active': '']">
						<button v-if="item.openAuth && !user" class="nav__link" @click="openAuth" type="button">{{item.text}}</button>
						<router-link v-else class="nav__link" :to="{name: item.link}">{{item.text}}</router-link>
					</li>
					<li class="nav__li">
						<a class="nav__link" :href="$root.$link.reviews" target="_blank">Отзывы</a>
					</li>
					<li class="nav__li" v-if="user && user.is_admin" >
						<a class="nav__link" href="/admin" target="_blank">ПУ</a>
					</li>
				</ul>
				<div class="nav__soc">
					<Social/>
				</div>
			</div>
		</transition>
	</teleport>
	<ul class="nav__list" v-else="">
		<li class="nav__li" v-for="item in currentItems" :class="[page === item.link ? 'active': '']">
			<button v-if="item.openAuth && !user" class="nav__link" @click="openAuth" type="button">{{item.text}}</button>
			<router-link v-else class="nav__link" :to="{name: item.link}">{{item.text}}</router-link>
		</li>
		<li class="nav__li">
			<a class="nav__link" :href="$root.$link.reviews" target="_blank">Отзывы</a>
		</li>
		<li class="nav__li" v-if="user && user.is_admin" >
			<a class="nav__link" href="/admin" target="_blank">ПУ</a>
		</li>
	</ul>
</nav>

</template>

<script>

import { mapState } from 'pinia';
import { useUserStore } from '../../stores/User';
import breakpointsMixin from '../../mixins/breakpoints-mixin.vue';
import scrollLock from "scroll-lock";
import Social from "./Social.vue";

export default {
	components: {
		Social
	},

	mixins: [
		breakpointsMixin
	],

	props: {
		page: {
			type: String,
			default: 'index'
		}
	},

	data() {
		return {
			open: false,
			items: [
				{
					text: 'Главная',
					link: 'index'
				},
				{
					text: 'FAQ',
					link: 'faq'
				},
				{
					text: 'Рефералы',
					link: 'revshare',
					authRequired: true
				},
				{
					text: 'Бонусы',
					link: 'bonus',
					openAuth: true
				},
				{
					text: 'Звания',
					link: 'rang'
				},
				{
					text: 'Настройки',
					link: 'settings',
					authRequired: true
				},
				{
					text: 'Выплаты',
					link: 'history'
				},
				{
					text: 'Топ игроков',
					link: 'leaderboard'
				},
				{
					text: 'Контакты',
					link: 'contacts'
				}
			]
		}
	},

	computed: {
		...mapState(useUserStore, ['user']),

		currentItems() {
			return this.user ? this.items : this.items.filter(item => !item.authRequired);
		}
	},

	watch: {
		$route (to, from){
			if (to.name !== from.name) this.open = false;
		},

		open(state) {
			scrollLock[state ? 'disablePageScroll' : 'enablePageScroll']();
		}
	},

	created() {
		this.$root.emitter.on('openNav', () => this.open = true);
	},

	methods: {
		openAuth() {
			this.open = false;
			this.$root.emitter.emit('openAuth', true);
		}
	}
}

</script>